import React from "react";
import HiddenDataTable from "../../../../../../components/HiddenDataTable";
import style from "./style.module.scss";
import ButtonIcon from "../../../../../../components/ButtonIcon/ButtonIcon";
import Filter from "../../../../../../assets/svg/icons/common/Filter";
import Download from "../../../../../../assets/svg/icons/common/Download";
import Table from "../../../../../../components/Table";
import Pagination from "../../../../../../components/Pagination/Pagination";
import Calender from "../../../../../../assets/svg/icons/common/Calender";
import CaretDown from "../../../../../../assets/svg/icons/common/CaretDown";
import master_card from "../../../../../../../../images/v2/master24x24.svg";
import CheckCircle from "../../../../../../assets/svg/icons/common/CheckCircle";
import MinusCircle from "../../../../../../assets/svg/icons/common/MinusCircle";
import useCommonStore from "../../../../../../stores/common";

function Interchange() {
  const expandDetails = useCommonStore((state) => state.expandDetails);

  const renderCardTypeCell = (data, row) => {
    return (
      <div className={style.cart_type_cell}>
        <img src={master_card} />
        <span>{data}</span>
      </div>
    );
  };

  const renderTotalCell = (data, row) => {
    return <span className={style.code_green}>{data}</span>;
    if (row.code.toLowerCase() == "sales")
      return <span className={style.code_green}>{data}</span>;
    if (row.code.toLowerCase() == "return")
      return <span className={style.code_red}>{data}</span>;
  };

  const tableColumns = [
    {
      headerName: "IC Level",
      field: "ic_level",
      width: 70,
      allowSort: true,
    },
    {
      headerName: "Cart type",
      field: "cart_type",
      width: 70,
      allowSort: true,
      renderCell: renderCardTypeCell,
    },
    {
      headerName: "MAS DESCRIPTION",
      field: "mas_description",
      width: 70,
      allowSort: true,
    },
    {
      headerName: "trans. count",
      field: "trans_count",
      width: 70,
      allowSort: true,
    },
    {
      headerName: "total",
      field: "total",
      width: 70,
      allowSort: true,
      renderCell: renderTotalCell,
    },
    {
      headerName: "YTD Trans. count",
      field: "ydt_trans_count",
      width: 70,
      allowSort: true,
    },
    {
      headerName: "YTD Total",
      field: "ytd_total",
      width: 70,
      allowSort: true,
      renderCell: renderTotalCell,
    },
  ];

  const data = [
    {
      ic_level: "123",
      cart_type: "MC",
      mas_description: "CPS/CNP DB",
      trans_count: "21",
      total: "($ 200.00)",
      ydt_trans_count: "$ 200",
      ytd_total: "1,345",
    },
    {
      ic_level: "123",
      cart_type: "MC",
      mas_description: "CPS/CNP DB",
      trans_count: "21",
      total: "($ 200.00)",
      ydt_trans_count: "$ 200",
      ytd_total: "1,345",
    },
    {
      ic_level: "123",
      cart_type: "MC",
      mas_description: "CPS/CNP DB",
      trans_count: "21",
      total: "($ 200.00)",
      ydt_trans_count: "$ 200",
      ytd_total: "1,345",
    },
    {
      ic_level: "123",
      cart_type: "MC",
      mas_description: "CPS/CNP DB",
      trans_count: "21",
      total: "($ 200.00)",
      ydt_trans_count: "$ 200",
      ytd_total: "1,345",
    },
    {
      ic_level: "123",
      cart_type: "MC",
      mas_description: "CPS/CNP DB",
      trans_count: "21",
      total: "($ 200.00)",
      ydt_trans_count: "$ 200",
      ytd_total: "1,345",
    },
    {
      ic_level: "123",
      cart_type: "MC",
      mas_description: "CPS/CNP DB",
      trans_count: "21",
      total: "($ 200.00)",
      ydt_trans_count: "$ 200",
      ytd_total: "1,345",
    },
    {
      ic_level: "123",
      cart_type: "MC",
      mas_description: "CPS/CNP DB",
      trans_count: "21",
      total: "($ 200.00)",
      ydt_trans_count: "$ 200",
      ytd_total: "1,345",
    },
    {
      ic_level: "123",
      cart_type: "MC",
      mas_description: "CPS/CNP DB",
      trans_count: "21",
      total: "($ 200.00)",
      ydt_trans_count: "$ 200",
      ytd_total: "1,345",
    },
  ];

  return (
    <>
      {!expandDetails && (
        <div className={style.container}>
          <HiddenDataTable />
        </div>
      )}

      {expandDetails && (
        <div className={style.container}>
          <header className={style.header}>
            <div className={style.left}>
              <h5>Card Summary</h5>
            </div>
            <div className={style.right}>
              <ButtonIcon bgColor={"#EDEDF4"}>
                <Calender />
                <span>01/01/24 - 25/01/24</span>
                <CaretDown />
              </ButtonIcon>
              <ButtonIcon bgColor={"#EDEDF4"}>
                <Filter />
              </ButtonIcon>
              <ButtonIcon bgColor={"#EDEDF4"}>
                <Download />
                <span>Download</span>
              </ButtonIcon>
            </div>
          </header>

          <div className={style.body}>
            <Table columns={tableColumns} data={data} />
          </div>

          <footer className={style.footer}>
            <Pagination />
          </footer>
        </div>
      )}
    </>
  );
}

export default Interchange;
